import { render, staticRenderFns } from "./EntrustControl.vue?vue&type=template&id=a9804632&scoped=true"
import script from "./EntrustControl.vue?vue&type=script&lang=js"
export * from "./EntrustControl.vue?vue&type=script&lang=js"
import style0 from "./EntrustControl.vue?vue&type=style&index=0&id=a9804632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9804632",
  null
  
)

export default component.exports